import React from "react";
import cx from "classnames";
import styles from "./Chip.module.scss";

export interface IChip {
  theme?: ThemeVariants;
  variant?: "filled" | "outline" | "empty" | "lightFilled";
  className?: string;
  icon?: React.ReactNode;
  iconVariant?: "filled" | "outline" | "empty" | "lightFilled";
  iconClassName?: string;
  style?: Record<string, any>;
  iconStyle?: Record<string, any>;
  onClick?: (e: any) => void;
  disabled?: boolean;
  condensed?: boolean;
  children: React.ReactNode;
}

const Chip = ({
  children,
  theme = "default",
  variant = "lightFilled",
  icon,
  iconVariant,
  className,
  style,
  iconStyle,
  iconClassName,
  onClick,
  condensed = false,
  disabled = false,
}: IChip) => {
  const v =
    variant && `variant${variant.charAt(0).toUpperCase() + variant.slice(1)}`;
  return (
    <div
      className={cx(
        styles.chip,
        styles[theme],
        styles[v],
        icon && styles.chipIcon,
        disabled && styles.disabled,
        condensed && styles.condensed,
        onClick && styles.clickable,
        className
      )}
      onClick={!disabled ? onClick : undefined}
      style={style}
    >
      {icon ? (
        <div className={styles.content}>
          <IconChip
            theme={theme}
            variant={iconVariant}
            className={iconClassName}
            style={iconStyle}
          >
            {icon}
          </IconChip>
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export interface IIconChip {
  theme?: ThemeVariants;
  variant?: "filled" | "outline" | "empty" | "lightFilled";
  className?: string;
  style?: Record<string, any>;
  children: React.ReactNode;
}

export const IconChip = ({
  theme = "default",
  variant = "filled",
  className,
  style,
  children,
}: IIconChip) => {
  const iV =
    variant && `icon${variant.charAt(0).toUpperCase() + variant.slice(1)}`;

  return (
    <div
      className={cx(styles[theme], styles.icon, styles[iV], className)}
      style={style}
    >
      {children}
    </div>
  );
};

export default Chip;
